import { all, fork, call, put, select, takeLatest } from 'redux-saga/effects';

import {
  FETCH_LIST_KAFKA_LOG,
  SAVE_KAFKA_LOG,
} from '../../constants/constant_saga_types';
import { fetchKafkaLogList } from '../../actions/actionCreatorKafkaLog';
import * as sagaCommon from '../sagasCommon';
import * as apiCommon from '../../services/apiCommon';
import * as apiKafkaLog from '../../services/kafka_log/api_kafka_log';

export default function*(app) {
  try {
    yield all([
      fork(fetchListKafkaLog, app),
      fork(pushToKafka, app),
    ]);
  } catch (e) {
    console.error('@saga_kafka_log', e);
  }
}

function* fetchListKafkaLog(app) {
  yield takeLatest(FETCH_LIST_KAFKA_LOG, callFetchListKafkaLog, app);
}

function* callFetchListKafkaLog(app, action) {
  const { silent, filters } = action;
  yield sagaCommon.showProgressListTable(silent);
  try {
    const { tenant: { id: tid } } = yield select();
    const dataParams = {
      filters: {
        ...filters,
        tid,
      },
      list_type: 'kafka_log',
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);
    yield call(sagaCommon.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield sagaCommon.showErrorListTable(error);
  }
}

function* pushToKafka(app) {
  yield takeLatest(SAVE_KAFKA_LOG, callPushToKafka, app);
}

function* callPushToKafka(app, action) {
  try {
    yield call(apiKafkaLog.pushToKafka, app, action);
    yield put(fetchKafkaLogList(false, {}));
  } catch (error) {
    yield sagaCommon.showErrorSaveRecord(error);
  }
}
